import { render, staticRenderFns } from "./LpuCardsChips.vue?vue&type=template&id=1296042b&scoped=true&"
import script from "./LpuCardsChips.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsChips.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsChips.vue?vue&type=style&index=0&id=1296042b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296042b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1296042b')) {
      api.createRecord('1296042b', component.options)
    } else {
      api.reload('1296042b', component.options)
    }
    module.hot.accept("./LpuCardsChips.vue?vue&type=template&id=1296042b&scoped=true&", function () {
      api.rerender('1296042b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsChips.vue"
export default component.exports